import { ChangeDetectorRef, Component, inject, OnInit } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { MatSnackBar, MatSnackBarConfig } from '@angular/material/snack-bar';
import { ActivatedRoute, Router } from '@angular/router';
import { forkJoin, Subscription, tap } from 'rxjs';
import { generateUUID } from 'src/app/core/generators/generateUUID';
import { isPlacaValida } from 'src/app/core/utils/utilities';
import {
  ICreateCavalo,
  IGetCavaloById,
  IItems
} from 'src/app/services/CavaloService/cavalo.model';
import { CavaloService } from 'src/app/services/CavaloService/cavalo.service';
import { SwalAlertService } from 'src/app/services/SwalAlertService/swalAlert.service';
import Swal from 'sweetalert2';
type IOptions = {
  name: string;
  value: string | number;
};

@Component({
  selector: 'app-cadastro-cavalo',
  templateUrl: './cadastro-cavalo.component.html',
  styleUrls: ['./cadastro-cavalo.component.scss']
})
export class CadastroCavaloComponent implements OnInit {
  private subscription$ = new Subscription();
  form = this._inicializarFormulario();
  activeRoute: string = '';
  pkCavalo: number = 0;
  isLoading: boolean = false;
  isEditing: boolean = false;
  disabledCavalo: boolean = false;
  title: string = 'Cadastro Cavalo';
  guid = generateUUID();

  private cavaloService = inject(CavaloService);

  cavaloOptions: IOptions[] = [
    {
      name: '',
      value: ''
    }
  ];

  tipoMarcaOptions: IOptions[] = [
    {
      name: 'Outros',
      value: 1
    },
    {
      name: 'DAF',
      value: 2
    },
    {
      name: 'Foton',
      value: 3
    },
    {
      name: 'Hyundai',
      value: 4
    },
    {
      name: 'Iveco',
      value: 5
    },
    {
      name: 'Mercedes-Benz',
      value: 6
    },
    {
      name: 'MAN',
      value: 7
    },
    {
      name: 'Scania',
      value: 8
    },
    {
      name: 'Volkswagen',
      value: 9
    }
  ];

  tipoCorOptions: IOptions[] = [
    {
      name: 'Outros',
      value: 0
    },
    {
      name: 'Branco',
      value: 1
    },
    {
      name: 'Prata',
      value: 2
    },
    {
      name: 'Cinza',
      value: 3
    },
    {
      name: 'Preto',
      value: 4
    },
    {
      name: 'Azul',
      value: 5
    },
    {
      name: 'Vermelho',
      value: 6
    },
    {
      name: 'Amarelo',
      value: 7
    }
  ];

  constructor(
    private fb: FormBuilder,
    private router: Router,
    private route: ActivatedRoute,
    private snackBar: MatSnackBar,
    private cd: ChangeDetectorRef,
    private swalAlert: SwalAlertService
  ) {}

  createPayload(): ICreateCavalo {
    const selectedValue = String(this.form.controls['TX_MDLO_CAVA'].value);
    const selectedMarca = this.tipoMarcaOptions.find(
      option => String(option.value) === selectedValue
    );

    const selectedValueCor = String(this.form.controls['TX_COR_CAVA'].value);
    const selectedCor = this.tipoCorOptions.find(
      option => String(option.value) === selectedValueCor
    );
    return {
      TX_PLCA_CAVA: String(
        this.form.controls['TX_PLCA_CAVA'].value
      ).toUpperCase(),
      TX_MDLO_CAVA: selectedMarca ? selectedMarca.name : '',
      NU_ANO_CAVA: String(this.form.controls['NU_ANO_CAVA'].value),
      TX_COR_CAVA: selectedCor ? selectedCor.name : '',
      NU_STTS_CAVA: 1,
      FK_MTRT_EXTR: Number(this.form.controls['FK_MTRT_EXTR'].value)
    };
  }

  private _inicializarFormulario() {
    const idMotorista = localStorage.getItem('id') || '1';
    const form = this.fb.group({
      TX_PLCA_CAVA: this.fb.control('', {
        nonNullable: true,
        validators: [Validators.required]
      }),
      TX_MDLO_CAVA: this.fb.control('', {
        nonNullable: true,
        validators: [Validators.required]
      }),
      NU_ANO_CAVA: this.fb.control('', {
        nonNullable: true,
        validators: [Validators.required]
      }),
      TX_COR_CAVA: this.fb.control('', {
        nonNullable: true,
        validators: [Validators.required]
      }),
      NU_STTS_CAVA: this.fb.control(1, { nonNullable: true }),
      FK_MTRT_EXTR: this.fb.control(Number(idMotorista))
    });
    return form;
  }

  obterDados() {
    this.subscription$.add(
      forkJoin([this.getPlacaCavalo()]).subscribe(() => {
        this.route.queryParams.subscribe(params => {
          if (params && Object.keys(params).length > 0) {
            this.title = 'Editar Cavalo';
            this.isEditing = true;
            this.disabledCavalo = false;
            this.cavaloService
              .GetCavaloById(Number(params['codigo']))
              .subscribe((response: IGetCavaloById) => {
                this.pkCavalo = response.PK_CAVA;
                this.form.controls['TX_PLCA_CAVA'].setValue(
                  response.TX_PLCA_CAVA ?? ''
                );
                const selectedMarca = this.tipoMarcaOptions.find(
                  option => option.name === response.TX_MDLO_CAVA
                );
                const selectedCor = this.tipoCorOptions.find(
                  option => option.name === response.TX_COR_CAVA
                );
                this.form.controls['TX_MDLO_CAVA'].setValue(
                  selectedMarca ? String(selectedMarca.value) : ''
                );
                this.form.controls['NU_ANO_CAVA'].setValue(
                  response.NU_ANO_CAVA ?? ''
                );
                this.form.controls['TX_COR_CAVA'].setValue(
                  selectedCor ? String(selectedCor.value) : ''
                );
                this.form.controls['NU_STTS_CAVA'].setValue(
                  response.NU_STTS_CAVA ?? 1
                );
                this.form.controls['FK_MTRT_EXTR'].setValue(
                  response.FK_MTRT_EXTR
                );
              });

            if (params['modoCavalo'] == 'Visualizar') {
              this.title = 'Visualizar Cavalo';
              this.form.disable();
              this.disabledCavalo = true;
            }
          }
        });
      })
    );
  }

  postarDados() {
    const payload = this.createPayload();

    if (this.form.valid) {
      const placaValida = isPlacaValida(this.form.controls.TX_PLCA_CAVA.value);
      if (placaValida) {
        this.isLoading = true;
        if (this.title.includes('Editar')) {
          this.cavaloService.EditarCavalo(this.pkCavalo, payload).subscribe(
            response => {
              this.isLoading = false;
              this.router.navigate(['motorista-externo/listagem/cavalo']);
            },
            error => {
              this.isLoading = false;
            }
          );
        } else if (this.title.includes('Cadastro'))
          this.cavaloService.CreateCavalo(payload, this.guid).subscribe(
            response => {
              this.isLoading = false;
              this.router.navigate(['motorista-externo/listagem/cavalo']);
            },
            error => {
              this.isLoading = false;
            }
          );
      } else {
        this.swalAlert.showAlert(
          'Atenção!',
          'Favor verificar se a placa informada está correta, pois possui apenas letras ou números.',
          'warning',
          false,
          false,
          undefined
        );
      }
    } else {
      this.isLoading = false;
      this.swalAlert.showAlert(
        'Atenção!',
        'Verifique se todos os campos obrigatórios foram preenchidos corretamente.',
        'warning',
        false,
        false,
        undefined
      );
    }
  }

  getPlacaCavalo() {
    this.isLoading = true;
    return this.cavaloService.GetCavalo({ paginar: false }).pipe(
      tap(response => {
        this.isLoading = false;
        this.cavaloOptions = response.ITEMS.map((x: IItems) => {
          return {
            name: x.TX_PLCA_CAVA,
            value: x.PK_CAVA
          };
        });
      })
    );
  }

  atualizarCampo(campo: string, valor: any): void {
    if (
      this.form.controls[campo as keyof typeof this.form.controls].value !==
      valor
    ) {
      const value = valor ?? '';
      this.form.controls[campo as keyof typeof this.form.controls].setValue(
        value as never
      );
    }
  }

  escolherOpcao(campo: string, options: any[], value: any): void {
    const selecionado = options.find(
      opcao => String(opcao.value) === String(value)
    );
    this.atualizarCampo(campo, selecionado?.value);
  }

  escolherTipoCarga(value: any): void {
    this.escolherOpcao('TX_MDLO_CAVA', this.tipoMarcaOptions, value);
  }

  escolherTipoCor(value: any): void {
    this.escolherOpcao('TX_COR_CAVA', this.tipoCorOptions, value);
  }

  exibirMensagem(mensagem: string, type: 'success' | 'error') {
    const config: MatSnackBarConfig = {
      duration: 3000,
      horizontalPosition: 'right',
      verticalPosition: 'top',
      panelClass: type === 'success' ? ['snackbar-success'] : ['snackbar-error']
    };

    this.snackBar.open(mensagem, 'Fechar', config);
  }

  public goTo(route: string) {
    this.router.navigate([route]);
    setTimeout(() => {
      this.activeRoute = this.router.url;
      this.cd.detectChanges();
    }, 200);
  }

  ngOnInit(): void {
    this.obterDados();
  }

  ngOnDestroy(): void {
    this.subscription$.unsubscribe();
  }
}
